import { Component, ViewChild, AfterViewInit, QueryList, ViewChildren, ElementRef } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ServicesService } from 'src/services/services.service';
import { SocketService } from 'src/services/socket.service';
import Swal from 'sweetalert2';
import * as QRCode from 'qrcode';
import { SecureStorageService } from 'src/services/secure-storage.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  standalone: false
})
export class PaymentComponent {
  reg_fee: any;
  payable_amount: any;
  coupon_amount: any;
  coupon_code: any;
  event_data: any;
  name: any;
  business_name: any;
  image: any;
  razorpay_key: any;
  event_image: any;
  reg_data: any;
  mobile: any;
  email: any;
  event_id: any;
  mem_id: any;
  coupon_data: any;
  error_msg: any;
  isValid = true;
  isExpired = false;
  showCouponCodeField = false;
  apply: string = "APPLY";
  payment_result: any;
  tic_category: any;
  allowed_person: any;
  event_logo: any;
  event_name: any;
  address: any;
  paymentData: any;
  qrData: any;
  upi_id: any;

  payment_option: string = "payment_gateway";

  // To hold references to all canvas elements
  // @ViewChildren('qrcodeCanvas') qrCodeCanvases: QueryList<ElementRef> | undefined;
  @ViewChild('canvas', { static: false }) canvas!: ElementRef;
  totalAmount: any;
  NavigationURL: any;
  category_id: any;
  category: any;
  total_base_price: number = 0;
  ticket_quantity: number = 0;
  total_booking_fee: number = 0;

  round_off_amount: number = 0;
  final_payable_amount: number = 0;

  readonly CONVENIENCE_PERCENT = 5.5;
  readonly GST_PERCENT = 18;

  // Original (per ticket total)
  original_convenience = 0;
  original_gst = 0;

  // Displayed (after coupon)
  display_convenience = 0;
  display_gst = 0;


  coupon_type: 'flat' | 'percentage' | null = null;

  sub_total: number = 0;
  discount_amount: number = 0;

  pricingData: any;

  base_price = 0;
  convenience_fee = 0;
  gst_amount = 0;
  total_charges = 0;
  other_charges = 0;
  total_amount = 0;


  constructor(
    private route: ActivatedRoute,
    private service: ServicesService,
    private PlatformLocation: PlatformLocation,
    private router: Router,
    private secureStorage: SecureStorageService,
  ) {

    // history.pushState(null, '', location.href);
    // this.PlatformLocation.onPopState(() => {
    //   history.pushState(null, '', location.href);
    // })

  }


  ngOnInit(): void {
    this.NavigationURL = sessionStorage.getItem('savedUrl');
    // const paymentData = JSON.parse(sessionStorage.getItem('paymentData')!);
    const paymentData = JSON.parse(this.secureStorage.getSession<any>('paymentData'));
    this.event_id = paymentData.event_id;
    this.mem_id = paymentData.mem_id;
    this.tic_category = paymentData.tic_category;
    this.reg_fee = paymentData.price;
    this.payable_amount = paymentData.price;

    this.Get_Event_By_Id(this.event_id);
    this.get_PaymentSetting(this.event_id);
    this.get_reg_by_id_web(this.event_id, this.mem_id);
    this.get_coupon_code();

  }

  calculateTotal() {
    this.totalAmount = this.tic_category.reduce((sum: any, item: any) => {
      const qty = Number(item.quantity) || 0;
      const price = Number(item.price) || 0;
      return sum + qty * price;
    }, 0);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.calculatePriceBreakdown();
      this.generateQRCode();
    }, 500);
  }

  onCodeChange(value: any) {
    this.coupon_code = value.replace(/\s+/g, '').toUpperCase();

    // 🔥 If user clears coupon by backspace
    if (!this.coupon_code || this.coupon_code.length === 0) {
      this.resetCouponState();
    }
  }

  resetCouponState() {
    this.apply = 'APPLY';
    this.coupon_amount = 0;
    this.coupon_type = null;
    this.discount_amount = 0;
    this.round_off_amount = 0;
    this.isValid = true;
    this.isExpired = false;

    this.calculateFinalAmount();
  }

  Get_Event_By_Id(event_id: any) {
    this.service.get_event_by_id(event_id).subscribe(
      (data: any) => {
        this.event_data = data.data;
        this.event_image = this.event_data[0].event_image;
        this.event_logo = this.event_data[0].event_logo;
        this.event_name = this.event_data[0].event_name;
        this.address = this.event_data[0].address;

      });
  }

  get_coupon_code_by_code(code: any) {
    if (code == " ") {
      console.log("aaaaaaa");
    }
    this.service.get_coupon_code_by_code(code, this.event_id).subscribe(
      (data: any) => {
        if (data.flag == true) {
          this.payment_result = data.data;
          if (this.payment_result[0].expired == true) {
            this.isExpired = true;
            this.isValid = true;
          } else {
            this.apply = "APPLIED";
            this.isExpired = false;
            this.isValid = true;
            this.coupon_amount = Number(this.payment_result[0].amount);
            this.coupon_type = this.payment_result[0].coupon_type == 'percentage' ? 'percentage' : 'flat';

            this.calculateFinalAmount();
          }
        } else {
          this.isExpired = false;
          this.isValid = false;
        }
      });
  }

  get_coupon_code() {
    this.service.check_coupon(this.event_id).subscribe(
      (data: any) => {
        this.showCouponCodeField = data.flag
      });
  }

  clearCode() {
    this.coupon_code = '';
    this.resetCouponState();
  }


  // Fetch Registration Data
  get_reg_by_id_web(event_id: any, mem_id: any) {
    this.service.get_reg_by_id_web(event_id, mem_id).subscribe({
      next: (data: any) => {
        this.reg_data = data.data[0];
        this.mobile = this.reg_data.mobile;
        this.name = this.reg_data.name;
        this.email = this.reg_data.email;
        this.allowed_person = this.reg_data.allowed_person;
        // this.payable_amount = this.reg_fee * this.allowed_person;
        const category_id = this.reg_data.category_id;
      },
      error: (error: any) => {
        console.error('Error fetching registration data:', error);
      }
    });
  }

  calculatePriceBreakdown() {
    const item = this.tic_category[0];
    this.ticket_quantity = Number(item.quantity) || 1;

    this.fetchPricing(item.category);
  }



  fetchPricing(category: string) {
    this.service.getTicketPricing(category, this.event_id)
      .subscribe((res: any) => {

        if (!res.flag) return;

        this.pricingData = res.data[0];

        this.base_price = Number(this.pricingData.ticket_amount);
        this.convenience_fee = Number(this.pricingData.total_convenience_fee);
        this.gst_amount = Number(this.pricingData.igst_amt);
        this.total_charges = Number(this.pricingData.total_charges);
        this.other_charges = Number(this.pricingData.other_charges);
        this.total_amount = Number(this.pricingData.total_amount);

        this.calculateFinalAmount();
      });
  }

  calculateFinalAmount() {

    if (!this.pricingData) return;

    /* -------- Per ticket total from API -------- */
    const perTicketTotal = Number(this.pricingData.total_amount);
    const total_before_coupon = perTicketTotal * this.ticket_quantity;

    /* -------- Coupon on FULL AMOUNT -------- */
    if (this.apply === 'APPLIED') {

      if (this.coupon_type === 'percentage') {
        this.discount_amount = +(
          (total_before_coupon * this.coupon_amount) / 100
        ).toFixed(2);
      } else {
        this.discount_amount = Number(this.coupon_amount);
      }

    } else {
      this.discount_amount = 0;
    }

    /* -------- Safety -------- */
    if (this.discount_amount > total_before_coupon) {
      this.discount_amount = total_before_coupon;
    }

    /* -------- Final Payable (NO ROUNDING) -------- */
    this.payable_amount = total_before_coupon - this.discount_amount;

    this.round_off_amount = 0;          // explicitly zero
    this.final_payable_amount = this.payable_amount;

    this.generateQRCode();
  }


  get_PaymentSetting(event_id: any) {
    this.service.getPaymentSetting(event_id).subscribe(
      (data: any) => {
        this.event_data = data.data;
        this.business_name = this.event_data[0].name;
        this.image = this.event_data[0].image;
        this.razorpay_key = this.event_data[0].razorpay_key;
        this.payment_option = this.event_data[0].payment_option;
        this.upi_id = this.event_data[0].upi_id;
      });
  }

  // Generate QR Code for each canvas element
  generateQRCode(): void {
    const upiUrl = 'upi://pay?pa=' + this.upi_id + '&pn=' + this.business_name + '&am=' + this.payable_amount + '&cu=INR';

    QRCode.toCanvas(this.canvas.nativeElement, upiUrl, { width: 256 }, (err) => {
      if (err) {
        console.error('QR generation failed:', err);
      } else {
        console.log('QR code generated');
      }
    });
  }

  pay() {
    if (this.apply != "APPLIED") {
      this.coupon_code = "";
    }

    if (this.payable_amount == 0) {

      if (this.payable_amount <= 0) {
        alert("INVALID AMOUNT!!!");
        return;
      }

      this.service.get_card(this.event_id).subscribe(
        (data: any) => {
          const card_image = data.data[0].image1;


          this.service.getsetting(this.event_id).subscribe(
            (data: any) => {
              const send_whatsapp_reg = data.data[0].send_whatsapp_reg;
              const reg_whatsapp_msg = data.data[0].reg_whatsapp_msg;

              if (send_whatsapp_reg == 'yes') {
                this.service.Generate_Card1(this.mem_id, this.event_id).subscribe(
                  () => {

                    const whatsapp_data = {
                      mem_id: this.mem_id,
                      name: this.name,
                      mobile: this.mobile,
                      email: this.email,
                    }
                    this.service.Send_Whatsapp(whatsapp_data, this.event_id, reg_whatsapp_msg).subscribe(
                      () => {
                        console.log("SUCCESS: ID CARD SENT ON WHATSAPP");
                        // this.navigateToRegistrationPage();
                      }
                    );

                  }
                );
              } else {
                console.log("SUCCESS");
                // this.navigateToRegistrationPage();
              }
            });
        });

      const tData = {
        amount: this.payable_amount,
        status: 'captured',
        coupon_code: this.coupon_code,
        event_id: this.event_id,
        mem_id: this.mem_id,
        tic_category: this.tic_category
      };

      this.service.edit_transaction_for_free(tData).subscribe(
        (data: any) => {

        });
      Swal.fire({
        title: "Registration Successful!",
        html: "<h1>Free entry!!! 🎉</h1>",
        icon: "success",
        background: '#ffffff',
        color: '#2c3e50', // Dark text color for contrast
        iconColor: '#27ae60', // Green icon for success
        confirmButtonText: 'Awesome! 👏',
        confirmButtonColor: '#2980b9', // Button color for confirmation
        timer: 10000,
        timerProgressBar: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown' // Add fade-in-down animation
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp' // Fade-out animation when closing
        },
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          this.router.navigate([this.NavigationURL]);
        }
      })
    } else {
      const orderData = {
        amount: this.payable_amount * 100,
        currency: 'INR',
        receipt: 'receipt#1',
        notes: { event_id: this.event_id, mem_id: this.mem_id, coupon_code: this.coupon_code, tic_category: this.tic_category }
      };

      this.service.createOrder(orderData).subscribe((data: any) => {
        const options = {
          key: this.razorpay_key,
          amount: this.payable_amount * 100,
          name: this.business_name,
          image: 'https://aieventzo.com/upload/payment_logo/' + this.image,
          order_id: data.id,
          handler: (response: any) => {
            this.router.navigateByUrl('/Success/' + this.event_id + '/' + response.razorpay_payment_id);
          },
          prefill: {
            contact: this.mobile
          },
          "notes": {
            "event_id": this.event_id,
            "name": this.name,
            "mobile": this.mobile,
            "mem_id": this.mem_id,
            "coupon_code": this.coupon_code,
            "tic_category": this.tic_category
          },
          theme: {
            color: '#3399cc'
          }
        };
        const rzp1 = new Razorpay(options);
        rzp1.on('payment.failed', (response: any) => {
          alert(response.error.reason);

          this.service.get_payment_details(response.error.metadata.payment_id, this.event_id).subscribe(
            (data: any) => {

            });

        });
        rzp1.open();
      });
    }


  }

  completePayment() {
    this.service.get_card(this.event_id).subscribe(
      (data: any) => {
        const card_image = data.data[0].image1;


        this.service.getsetting(this.event_id).subscribe(
          (data: any) => {
            const send_whatsapp_reg = data.data[0].send_whatsapp_reg;
            const reg_whatsapp_msg = data.data[0].reg_whatsapp_msg;

            if (send_whatsapp_reg == 'yes') {
              this.service.Generate_Card1(this.mem_id, this.event_id).subscribe(
                () => {

                  const whatsapp_data = {
                    mem_id: this.mem_id,
                    name: this.name,
                    mobile: this.mobile,
                    email: this.email,
                  }
                  this.service.Send_Whatsapp(whatsapp_data, this.event_id, reg_whatsapp_msg).subscribe(
                    () => {
                      console.log("SUCCESS: ID CARD SENT ON WHATSAPP");
                      // this.navigateToRegistrationPage();
                    }
                  );

                }
              );
            } else {
              console.log("SUCCESS");
              // this.navigateToRegistrationPage();
            }
          });
      });

    const tData = {
      amount: this.payable_amount,
      status: 'captured',
      coupon_code: this.coupon_code,
      event_id: this.event_id,
      mem_id: this.mem_id,
      tic_category: this.tic_category
    };

    this.service.edit_transaction_for_free(tData).subscribe(
      (data: any) => {

      });
    Swal.fire({
      title: "Registration Successful!",
      html: "<h1>Free entry!!! 🎉</h1>",
      icon: "success",
      background: '#ffffff',
      color: '#2c3e50', // Dark text color for contrast
      iconColor: '#27ae60', // Green icon for success
      confirmButtonText: 'Awesome! 👏',
      confirmButtonColor: '#2980b9', // Button color for confirmation
      timer: 10000,
      timerProgressBar: true,
      showClass: {
        popup: 'animate__animated animate__fadeInDown' // Add fade-in-down animation
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp' // Fade-out animation when closing
      },
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then((result) => {
      if (result.isConfirmed || result.isDismissed) {
        this.router.navigate([this.NavigationURL]);
      }
    })
  }
}
